import { BorrowerModel } from '../../cmg-1003/models/borrower.model';

/**
 * Sorts entities to have the primary borrower first, followed by additional borrower.
 * @param entities An array of entities. Generic, but must have { borrowerId?: number }.
 * @param borrowers An array of borrowers - BorrowerModel[].
 * @returns A sorted array of entities.
 */
export const sortEntitiesByBorrowers = <T extends { borrowerId?: number }>(entities: T[], borrowers: BorrowerModel[]) => {
  const sortedEntities = [];
  const sortedBorrowers = borrowers.sort((a, b) => (a.isPrimaryBorrower === b.isPrimaryBorrower ? 0 : a.isPrimaryBorrower ? -1 : 1));

  sortedBorrowers.forEach((sb) => {
    const matchingEntities = entities.filter((e) => e.borrowerId === sb.borrowerId);

    if (matchingEntities.length > 0) {
      sortedEntities.push(matchingEntities[0]);
    }
  });

  return sortedEntities;
};
